// src/pages/Contacts.jsx
import React from 'react';
import ContactsSection from '../components/ContactsSection';

export default function Contacts() {
  return <ContactsSection />;
}